import {
  appendData,
  deleteData,
  getDataOnce,
  updateData,
  flatten,
} from "./helper";

class DbEngine {
  constructor(nodeName) {
    this.nodeName = `${nodeName}`;
  }

  create = async (obj) => {
    return await appendData(obj, this.nodeName);
  };

  update = async (details, id) => {
    return await updateData(details, `${this.nodeName}/${id}`);
  };

  delete = async (id) => {
    return await deleteData(`${this.nodeName}/${id}`);
  };

  read = async (flat = true) => {
    const data = await getDataOnce(this.nodeName);
    if (flat) {
      return flatten(data);
    }
    return data;
  };
}

export default DbEngine;
